import PropTypes from 'prop-types'
import { XamaLogo } from '../../assets/svgs/icons'
import { ModalComponent } from '../../components/ModalComponent'
import { StarRating } from './StarRating'
import styles from './styles.module.css'

export const SatisfactionPopUp = ({
  title,
  isOpen,
  primaryButton,
  secondaryButton,
  onClickPrimaryBtn,
  onClickSecondaryBtn,
  onChangeStars,
  content
}) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      className={styles.modalContainer} 
    >
      <div
        className={styles.modalContentContainer}
      >
        <div>
          <XamaLogo />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            textAlign: 'justify',
            justifyContent:'center',
            alignItems:'center',
            gap:'20px'
          }}
        >
          <h1
           
          >
            {title}
          </h1>
          <div className={styles.modalContentContainer}>
            <p className={styles.modalContentContainerText}>
              {content}
            </p>
            <StarRating onChangeRating={onChangeStars}/>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div
            onClick={onClickPrimaryBtn}
            style={{
              boxShadow: '0px 14px 40px 2px #6A009890',

              borderRadius: '40px', // Adicionando border-radius para acompanhar o botão
            }}
          >
            {primaryButton && (
              <button
                className={styles.primaryButton}>
                {primaryButton}
              </button>
            )}
          </div>
          {secondaryButton && (
            <button
              onClick={onClickSecondaryBtn}
              className={styles.secondaryButton}
            >
              {secondaryButton}
            </button>
          )}
        </div>
      </div>
    </ModalComponent>
  )
}

SatisfactionPopUp.propTypes = {
  title: PropTypes.node,
  content:PropTypes.string,
  primaryButton:PropTypes.node,
  secondaryButton:PropTypes.node,
  onClickPrimaryBtn:PropTypes.func,
  onClickSecondaryBtn:PropTypes.func,
  onChangeStars:PropTypes.func,
  isOpen:PropTypes.bool
}